import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import styles from '../sass/selectaddress.module.scss'
import { useSelector, useDispatch } from 'react-redux'
import { fetchCountry, fetchStates, storeAddress } from '../redux/actions/addressActions'
import { toast } from 'react-toastify'

const NewAddressModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const { userDetails, token } = useSelector((state) => state.user);
  const { countries, states, loader } = useSelector((state) => state.userAddress);
  const user_id = userDetails?.id;
  const [error, setError] = useState({});

  const [form, setForm] = useState({
    user_id: userDetails.id,
    fname: "",
    lname: "",
    phone: "",
    alt_phone: "",
    address: "",
    country_id: 1,
    state_id: "",
    city: "",
    pincode: "",
    landmark: "",
    gstin: "",
    dla: "",
    address_type: "House",
    is_default: false,
  });

  useEffect(() => {
    if (user_id && token) {
      dispatch(fetchCountry());
      dispatch(fetchStates());
    }
  }, [dispatch, user_id, token]);

  // const handleChange = (key, value) => {
  //   setForm({ ...form, [key]: value });
  // };

  const handleChange = (key, value) => {
    const formatValue = (val) => {
        // If the key is 'gstin', convert to uppercase
        if (key === "gstin") return String(val).toUpperCase(); 

        // If the value is not a string (e.g., boolean), return as is
        if (typeof val !== "string") return val; 

        // Capitalize each word
        return val.replace(/\b\w/g, (char) => char.toUpperCase());
    };

    setForm({ ...form, [key]: formatValue(value) });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      // Dispatch API request
      await dispatch(storeAddress(form)).unwrap();
      toast.success("Address added successfully!");
      setError({});
      onClose();
    } catch (error) {
      if (error.errors) {
        // Backend sends errors as an object with arrays, extract first message of each field
        const formattedErrors = Object.keys(error.errors).reduce((acc, key) => {
          acc[key] = error.errors[key][0]; // Take the first error message for each field
          return acc;
        }, {});
  
        setError(formattedErrors);
      } else {
        // General error message
        setError({ general: error.message || "Something went wrong!" });
      }
    }
  };
  
  return (
    <div className={`modal-overlay ${styles.ModalOverlaySection}`} onClick={onClose}>
        <div className={`modal-content ${styles.ModalDrawerContainer}`} onClick={(e) => e.stopPropagation()}>
            <div className={styles.AddressOnCart_stickyHeader}>
              <div className={styles.AddressOnCart_header}>
                  <div className={styles.AddressOnCart_backButton} onClick={onClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class=""><path d="M19 12H5" stroke="#30363C" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11 18L5 12L11 6" stroke="#30363C" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </div>
                  <div className={styles.AddressOnCart_addressHeadingText}>Add Address</div>
              </div>
            </div>
            <div className={styles.AddressForm_addressWrapper}>
                <div className={styles.AddressForm_newAddressDrawerOverflowWrapper}>
                  <form className={styles.AddressForm_newform} onSubmit={handleSubmit}>
                    {error.general && <div className={styles.ErrorMessage}>{error.general}</div>}
                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.Input_addressformrow}>
                        <input 
                          className={styles.AddressForm_newAddressFormInput} 
                          value={form.fname}
                          onChange={(e) => handleChange('fname', e.target.value)}
                          placeholder=" "
                        />
                        <label className={styles.Input_addressformlabel}>First Name<span> *</span></label>
                      </div>
                      {error.fname && <div className={styles.ErrorMessage}>{error.fname}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.Input_addressformrow}>
                        <input 
                          className={styles.AddressForm_newAddressFormInput} 
                          value={form.lname}
                          onChange={(e) => handleChange('lname', e.target.value)}
                          placeholder=" "
                        />
                        <label className={styles.Input_addressformlabel}>Last Name<span> *</span></label>
                      </div>
                      {error.lname && <div className={styles.ErrorMessage}>{error.lname}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.Input_addressformrow}>
                        <span className={styles.PhonePrefix}>+91</span>
                        <input 
                          type="number"
                          className={`${styles.AddressForm_newAddressFormInput} ${styles.PhoneInput}`}  
                          value={form.phone}
                          onChange={(e) => handleChange('phone', e.target.value)}
                          placeholder=" "
                        />
                        <label className={styles.Input_addressformlabel}>Phone<span> *</span></label>
                      </div>
                      {error.phone && <div className={styles.ErrorMessage}>{error.phone}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.Input_addressformrow}>
                        <span className={styles.PhonePrefix}>+91</span>
                        <input 
                          type="number"
                          className={`${styles.AddressForm_newAddressFormInput} ${styles.PhoneInput}`}   
                          value={form.alt_phone}
                          onChange={(e) => handleChange('alt_phone', e.target.value)}
                          placeholder=" "
                        />
                        <label className={styles.Input_addressformlabel}>Alternate Phone</label>
                      </div>
                      {error.alt_phone && <div className={styles.ErrorMessage}>{error.alt_phone}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.Input_addressformrow}>
                        <input 
                          className={styles.AddressForm_newAddressFormInput} 
                          value={form.address}
                          onChange={(e) => handleChange('address', e.target.value)}
                          placeholder=" "
                        />
                        <label className={styles.Input_addressformlabel}>Address<span> *</span></label>
                      </div>
                      {error.address && <div className={styles.ErrorMessage}>{error.address}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <label className={styles.Input_addressformlabel_select}>Country</label>
                      <Select
                        value={countries
                          .map(country => ({ label: country.name, value: country.id }))
                          .find(option => option.value === form.country_id)}
                        options={countries.map(country => ({ label: country.name, value: country.id }))}
                        styles={customStyles}
                        onChange={(selectedOption) => handleChange('country_id', selectedOption.value)}
                        isDisabled={true}
                      />
                      {error.country_id && <div className={styles.ErrorMessage}>{error.country_id}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <label className={styles.Input_addressformlabel_select}>State</label>
                      <Select
                        value={states
                          .map(state => ({ label: state.name, value: state.id }))
                          .find(option => option.value === form.state_id)}
                        options={states.map(state => ({ label: state.name, value: state.id }))}
                        styles={customStyles}
                        onChange={(selectedOption) => handleChange('state_id', selectedOption.value)}
                      />
                      {error.state_id && <div className={styles.ErrorMessage}>{error.state_id}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.Input_addressformrow}>
                        <input 
                          className={styles.AddressForm_newAddressFormInput} 
                          value={form.city}
                          onChange={(e) => handleChange('city', e.target.value)}
                          placeholder=" "
                        />
                        <label className={styles.Input_addressformlabel}>City <span> *</span></label>
                      </div>
                      {error.city && <div className={styles.ErrorMessage}>{error.city}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.Input_addressformrow}>
                        <input
                          className={styles.AddressForm_newAddressFormInput}
                          type="number"
                          value={form.pincode}
                          onChange={(e) => handleChange('pincode', e.target.value)}
                          placeholder=" "
                        />
                        <label className={styles.Input_addressformlabel}>Pincode <span> *</span></label>
                      </div>
                      {error.pincode && <div className={styles.ErrorMessage}>{error.pincode}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.Input_addressformrow}>
                        <input
                          className={styles.AddressForm_newAddressFormInput}
                          value={form.landmark}
                          onChange={(e) => handleChange('landmark', e.target.value)}
                          placeholder=" "
                        />
                        <label className={styles.Input_addressformlabel}>Landmark</label>
                      </div>
                      {error.landmark && <div className={styles.ErrorMessage}>{error.landmark}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.Input_addressformrow}>
                        <input 
                          className={styles.AddressForm_newAddressFormInput} 
                          value={form.gstin}
                          onChange={(e) => handleChange('gstin', e.target.value)}
                          placeholder=" "
                        />
                        <label className={styles.Input_addressformlabel}>GSTIN <small>(Optional)</small></label>
                      </div>
                      {error.gstin && <div className={styles.ErrorMessage}>{error.gstin}</div>}
                    </div>

                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.Input_addressformrow}>
                        <input 
                          className={styles.AddressForm_newAddressFormInput} 
                          value={form.dla}
                          onChange={(e) => handleChange('dla', e.target.value)}
                          placeholder=" "
                        />
                        <label className={styles.Input_addressformlabel}>Drug License <small>(Optional)</small></label>
                      </div>
                      {error.dla && <div className={styles.ErrorMessage}>{error.dla}</div>}
                    </div>

                    {/* Set as Default Toggle */}
                    <div className={styles.Input_addressFormGroup}>
                      <div className={styles.SwitchContainer}>
                        <label className={styles.Input_addressformlabel_select}>Set as Default</label>
                        <label className={styles.CustomSwitchLabel}>
                          <input 
                            type="checkbox" 
                            checked={form.is_default} 
                            onChange={(e) => handleChange("is_default", e.target.checked)}
                            className={styles.CustomSwitchInput}
                          />
                          <span className={styles.CustomSwitchSlider}></span>
                        </label>
                      </div>
                    </div>


                    <div className={styles.AddressForm_newFormNoBorder}>
                      <button
                        type={loader ? "button" : "submit"}
                        disabled={loader}
                        className={`Button_container ${styles.AddressOnCart_buttonContinue}`}
                        aria-busy={loader}
                      >
                        {loader ? "Please wait..." : "Save and Continue"}
                      </button>
                    </div>

                  </form>
                </div>

                {/* <div className={styles.AddressOnCart_saveAndContinueWrapper}>
                </div> */}
            </div>
        </div>
    </div>
  )
}

export default NewAddressModal


const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: '48px',
    borderColor: provided.isFocused ? 'red' : '#E6EBF4',
    boxShadow: 'none',
    borderRadius: 8,
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 10, // Make sure the dropdown is visible above other content
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#30363C', // Ensuring the text color is visible
    fontSize: 14,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#1565C0' : state.isFocused ? '#F0F0F0' : 'white',
    color: state.isSelected ? 'white' : '#30363C',
    fontSize: 14
  }),
};
